export default "__VITE_ASSET__B_$SbzO4__"